// import getRelativeUrl from '@ep/utils/getRelativeUrl';

const externalHrefRegex = /href="[^\/\#][^"]*"/g;

function getRelativeUrl(html: string | null | undefined) {
  if (html?.slice(0, 20) === 'href="https://ep.com') {
    return `href="${html.slice(20)}`;
  } else if (html?.slice(0, 24) === 'href="https://www.ep.com') {
    return `href="${html.slice(24)}`;
  } else {
    return html;
  }
}

function getHtmlProp(html: string | null | undefined) {
  return {
    dangerouslySetInnerHTML: {
      __html:
        html?.replace(externalHrefRegex, match => `${getRelativeUrl(match)}`) ||
        '',
    },
  };
}

export default getHtmlProp;
